<template>
  <div class="event-button-create" @click="create">
    イベントの作成
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    create: async function () {
      const result = await this.$store.dispatch(
        'event/saveEvent',
        'new'
      )
      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.event-button-create {
  @include button-ol-success;
}
</style>
